<template>
    <Head title="Privacidade" />
    <div class="h-[100vh]">
        <PagesLayout>
        <HeaderComponent :showExtras="false" />
        <Heading title="Privacidade" class="xl:px-[220px] xl:pt-6 sm:pl-6 sm:pt-6"/>
        <div class="p-4 xl:px-[16vw] min-h-[70vh] component-background-desktop">
            <button @click="goBack" :class="stateBack" class="py-5 back-sm hover:text-blue-600 hover:underline text-blue-300">Voltar</button>
            <article class="mb-5">
                <div v-html="privacy.text"></div>
            </article>
            <!-- <PrivacyMockado/> -->
        </div>
        </PagesLayout>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import Heading from '@/Components/UI/Texts/Heading.vue'
import PagesLayout from "@/Layouts/Pages.vue";
import PrivacyComponent from "@/Pages/PrivacyComponent.vue";
import PrivacyMockado from '@/Components/PrivacyMockado.vue'

export default {
  components: {
    Head,
    Heading,
    PagesLayout,
    PrivacyComponent,
    PrivacyMockado
  },
  props: {
    privacy: Object,
  },
  methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
}
</script>
